// Array global en memoria
const seleccionTemporal = [];

/**
 * Reemplaza todo lo de un (contenedorId, pedidoId) por el nuevo “estado deseado”
 * Cada registro trae cómo estaba en BD (baselineAsociada) y cómo lo quieres ahora (asociada)
 */
export const guardarSeleccion = (contenedorId, pedidoId, nuevosRegistros = []) => {
  // 1) Conservo todo lo que NO es de este (contenedor, pedido)
  const anteriores = seleccionTemporal.filter(
    it => !(String(it.contenedorId) === String(contenedorId) && String(it.pedidoId) === String(pedidoId))
  );

  // 2) Normalizo lo nuevo (puede haber true o false)
  const normalizados = nuevosRegistros.map(it => ({
    idListaEmpaque: it.idListaEmpaque,
    pedidoId,
    contenedorId,
    // cómo estaba en BD:
    baselineAsociada: !!it.baselineAsociada,
    // cómo lo quieres ahora:
    asociada: !!it.asociada,
    // datos para sumar/restar
    CBM: Number(it.CBM ?? it.CBMTotal ?? it.CubCaja ?? it.cbm ?? 0),
    PesoCaja: Number(it.PesoCaja ?? it.Peso ?? it.PesoBruto ?? it.peso ?? 0),
    TipoMcia: it.TipoMcia || 'N',
  }));

  // 3) Reemplazo en memoria
  seleccionTemporal.splice(0, seleccionTemporal.length, ...anteriores, ...normalizados);
};

export const obtenerTodo = () => seleccionTemporal;
export const limpiarTodo = () => { seleccionTemporal.length = 0; };

// (opcional) ids por pedido
export const obtenerSeleccionPorPedido = (contenedorId, pedidoId) =>
  seleccionTemporal
    .filter(it => String(it.contenedorId) === String(contenedorId) && String(it.pedidoId) === String(pedidoId))
    .map(it => it.idListaEmpaque);

export const limpiarSeleccionContenedor = () => localStorage.removeItem('seleccionesLE');
